import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    error?: string;
}

const Input: React.FC<InputProps> = ({ label, error, className = '', ...props }) => {
    return (
        <div className={`flex flex-col gap-1.5 w-full ${className} animate-fade-in`}>
            {label && (
                <label className="text-sm font-semibold text-slate-700 ml-1">
                    {label}
                </label>
            )}
            <input
                className={`input-premium ${error ? 'border-red-400 focus:ring-red-200' : ''}`}
                {...props}
            />
            {error && <p className="text-xs text-red-500 font-medium ml-1 mt-0.5">{error}</p>}
        </div>
    );
};

export default Input;
